export default __webpack_public_path__ + "static/media/jeans_1.3c8d5216.jpg";